define('TescoMobile_Checkout/js/model/no-addresses-listed-modal',['jquery', 'Magento_Ui/js/modal/modal', 'mage/collapsible'], function ($, modal) {
  'use strict';

  return {
    modalWindow: null,
    createModal: function (element) {
      this.modalWindow = element;
      modal({
        modalClass: 'no-address-listed-modal without-header',
        responsive: true,
        innerScroll: true,
        trigger: '.show-modal',
        type: 'slide',
        buttons: [],
        clickableOverlay: false,
        opened: function () {
          $(".collapsible-detail").collapsible({
            "openedState": "active"
          });
        }
      }, $(this.modalWindow));
    },
    showModal: function () {
      $(this.modalWindow).modal('openModal');
    },
    closeModal: function () {
      $(this.modalWindow).modal('close');
    }
  };
});

